import GoToHistoryCell from 'src/components/GoToHistoryCell';
import { GridColumn } from 'src/components/GridWrapper';
import { PoHistoryObject } from 'src/services/usePoHistoryApi';

export const poHistoryColumns: GridColumn<PoHistoryObject>[] = [
  {
    field: 'action',
    title: 'Action',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
  {
    field: 'actionDate',
    title: 'Action Date',
    filter: 'date',
    format: '{0:EEEE, MMMM d, y h:mm:ss a}',
    dataType: 'date',
    width: '200px',
  },
  {
    field: 'transactionNotes',
    title: 'Notes',
    filter: 'text',
    format: '',
    dataType: 'string',
    width: '220px',
  },
  {
    field: 'document',
    title: 'Document',
    filter: 'text',
    component: GoToHistoryCell,
    width: '220px',
    format: '',
    dataType: 'string',
  },
];

export default poHistoryColumns;
